import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

import { WINDOW_PRESETS } from "./fleetWindow";

/** The history window: which clips the chart, the worker cards and the clip list cover. */
export function WindowToggle({
  value,
  onChange,
}: {
  value: number;
  onChange: (hours: number) => void;
}) {
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      value={String(value)}
      onValueChange={(next) => {
        if (next) onChange(Number(next));
      }}
      aria-label="History window"
    >
      {WINDOW_PRESETS.map((preset) => (
        <ToggleGroupItem
          key={preset.hours}
          value={String(preset.hours)}
          className="px-2.5 text-xs"
          title={`Clips finished in the last ${preset.label}`}
        >
          {preset.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
